import { makeAutoObservable } from 'mobx'

const normalizeId = value => String(value || '').trim()

class StudentApplicationsStore {
	studentId = null
	applications = []
	loadStatus = 'idle'

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true })
	}

	ensureStudent(studentId) {
		const id = normalizeId(studentId)
		if (this.studentId === id) return
		this.studentId = id
		this.applications = []
		this.loadStatus = 'idle'
	}

	hasDataFor(studentId) {
		return (
			this.studentId === normalizeId(studentId) && this.applications.length > 0
		)
	}

	setLoading(studentId) {
		if (this.studentId !== normalizeId(studentId)) return
		this.loadStatus = 'loading'
	}

	setApplications(studentId, applications) {
		if (this.studentId !== normalizeId(studentId)) return
		this.applications = Array.isArray(applications) ? applications : []
		this.loadStatus = 'success'
	}

	setError(studentId) {
		if (this.studentId !== normalizeId(studentId)) return
		this.loadStatus = 'error'
	}
}

export const studentApplicationsStore = new StudentApplicationsStore()
